import { Chip } from "@heroui/react";
import { getCountdownLabel, isMeetingActive, isMeetingPast, isMeetingUpcoming } from "@/utils/dates";

const STARTING_SOON_MINUTES = 2;

const resolveTiming = (loop) => {
  if (!loop) return null;

  const date = loop.meets_date ?? loop.meeting_date;

  const start = typeof loop.start_time === "string" ? loop.start_time : loop.start_time?.set;

  const end = typeof loop.end_time === "string" ? loop.end_time : loop.end_time?.real || loop.end_time?.set;

  if (!date || !start) return null;

  return { date, start, end };
};

const getMinutesUntil = (date, time) => {
  const target = new Date(`${date}T${time}`);
  if (Number.isNaN(target.getTime())) return null;

  return (target - new Date()) / 60000;
};

const CountdownBadge = ({ loop, size = "sm", className }) => {
  const timing = resolveTiming(loop);
  if (!timing) return null;

  const { date, start, end } = timing;

  // Happening right now
  if (end && isMeetingActive(date, start, end)) {
    return (
      <Chip variant="soft" color="success" size={size} className={className}>
        <Chip.Label>Active now</Chip.Label>
      </Chip>
    );
  }

  if (end && isMeetingPast(date, end)) {
    return (
      <Chip variant="soft" color="warning" size={size} className={className}>
        <Chip.Label>Past</Chip.Label>
      </Chip>
    );
  }

  if (isMeetingUpcoming(date, start)) {
    const minutesUntil = getMinutesUntil(date, start);

    // About to start — sits between "In 5m" and "Active now"
    if (minutesUntil !== null && minutesUntil <= STARTING_SOON_MINUTES) {
      return (
        <Chip variant="soft" color="danger" size={size} className={className}>
          <Chip.Label>Starting now</Chip.Label>
        </Chip>
      );
    }

    return (
      <Chip variant="soft" color="accent" size={size} className={className}>
        <Chip.Label>{getCountdownLabel(date, start)}</Chip.Label>
      </Chip>
    );
  }

  return null;
};

export default CountdownBadge;